import { AllocateSingleId } from "../AllocateId";
import { GetMasterTableEntries } from "../GetMasterTableEntries";
import { DeleteFromServer, FetchFromServer, SaveToServer } from "../Post";

const MasterTableName = "GAAProjectRBItemServingSlotMaster";
const FetchRequestType = "GAAProjectRBItemServingSlotFetchRequest";

// Save All Data To Database //
export const SaveRBItemServingSlot = async (ref, payload) => {
  payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, []);
};
// Get All Data From Database //
export const GetRBItemServingSlotList = async () => {
  let payload = { Refs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  result = result.sort((a, b) => a.Name.localeCompare(b.Name));
  return result;
};

// Get Single Data From Database //
export const GetRBItemServingSlot = async (Ref) => {
  let payload = {GAAProjectRBItemServingSlotRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};

export const DeleteRBItemServingSlot = async (payload) => {
  return await DeleteFromServer(payload, MasterTableName);
};

export const GetRBItemServingSlotListByProject = async (GAAProjectRef) => {
  let payload = { GAAProjectRefs: [GAAProjectRef]};
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  return result;
};

